module.exports = __webpack_public_path__ + "static/media/close-icon.94de8f33.png";